import { type ColumnElementType, type ColumnStyleType } from '../../types';

export const elementsOrderMap: Record<ColumnStyleType, ColumnElementType[]> = {
  style1: ['picture', 'title', 'features', 'price', 'button'],
  style2: ['picture', 'title', 'features', 'price', 'button'],
  style3: ['picture', 'title', 'features', 'price', 'button'],
  style4: ['picture', 'title', 'price', 'button', 'features'],
  style5: ['picture', 'title', 'price', 'button', 'features'],
  style6: ['picture', 'title', 'price', 'button', 'features']
};
